/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Row } from "reactstrap";
import PageHeader from "../../../components/PageHeader";
import { ColCard } from "../../../components/ContentLayout";
import TaxAccountantInfo from "../../../components/TaxPortal/Settings/TaxAccountantInfo";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import { viewLoading } from "../../../utils/loading";
import { getTaxAccountantFinancesAccounts } from "../../../apis/tax-accountant-finance/auth";
import { FINANCE_SCRAPING_STATE } from "../../../constants/SCRAPING_DATA";
import { SI4N_TYPES } from "../../../constants/TaxPortal/SI4N";
import TaxAccountNationalPensionCert from "../../../components/TaxPortal/Settings/TaxAccountNationalPensionCert";
import systemAlert from "../../../utils/systemAlert";
import TaxAccountHealthInsuranceCert from "../../../components/TaxPortal/Settings/TaxAccountHealthInsuranceCert";

const TaxportalSettingsSi4n = () => {
  const history = useHistory();
  const [activeTab, setActiveTab] = useState(null);

  const _setActiveTab = (value) => {
    const newTab = SI4N_TYPES.find((item) => item.id === value) || SI4N_TYPES[0];
    if (newTab.disabled) return systemAlert('준비중입니다.')
    setActiveTab(newTab);
    history.push(`/tax-portal/settings/si4n?tab=${value}`);
  };

  const tabList = SI4N_TYPES.map((item) => ({
    label: item.label,
    action: () => _setActiveTab(item.id),
    value: item.id,
  }));

  useEffect(() => {
    const query = queryString.parse(history.location.search);
    if (!query.tab) return
    const selectedTab = SI4N_TYPES.find((item) => item.id === query.tab) || SI4N_TYPES[0];
    setActiveTab(selectedTab);
  }, [history.location]);

  const [accountInfo, setAccountInfo] = useState({});
  const [state, setState] = useState({});

  useEffect(() => {
    if (!activeTab) return
    setAccountInfo({})
    getAccount();
  }, [activeTab]);

  const getAccount = () => {
    viewLoading(true);
    const newTab = SI4N_TYPES.find((item) => item.id === activeTab?.id) || SI4N_TYPES[0];
    getTaxAccountantFinancesAccounts(`tax-accountant-${newTab.shotId}`)
      .then((res) => {
        res = res.data.accounts.find((account) => account.orgCd === `tax-accountant-${newTab.shotId}`);
        const state = FINANCE_SCRAPING_STATE.find(state => state.value === res?.financeScrapings[0]?.state);
        setState(state);
        setAccountInfo(res);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => viewLoading(false));
  };

  return (
    <>
      <PageHeader
        title={`4대보험 설정`}
        activeTab={activeTab?.id}
        tabList={tabList}
      />
      <div className="automatic-setting" style={{ maxWidth: '800px' }}>
        <section id="section-one">
          <>
            <Row>
              <ColCard>
                <TaxAccountantInfo />
              </ColCard>
            </Row>
            {activeTab?.id === SI4N_TYPES[0].id && (
              <TaxAccountNationalPensionCert
                accountInfo={accountInfo}
                state={state}
                getAccount={getAccount}
              />
            )}
            {activeTab?.id === SI4N_TYPES[1].id && (
              <TaxAccountHealthInsuranceCert
                accountInfo={accountInfo}
                state={state}
                getAccount={getAccount}
              />
            )}
          </>
        </section>
      </div>
    </>
  );
};

export default TaxportalSettingsSi4n;